/**
 * Подпись графика формулой: потолок длины и версии вида
 * (`docs/graph-formula-label-design.md`, 3.4).
 *
 * ⚠️ **Файл ЛИСТОВОЙ: ни zod, ни одного импорта.** Читают его трое (схемы
 * элемента и ответа, сервер при приёме ответа рисователя, клиент при решении
 * «показывать ли» и «дозаливать ли»), и число, заведённое в трёх местах,
 * однажды разъедется.
 */

/** Длина TeX одного выражения. Длиннее это отказ подписи, а не срез. */
export const LABEL_TEX_MAX = 2000;

/**
 * Версия вида подписи. ⚠️ Поднимать при ЛЮБОЙ правке печатника
 * (`apps/api/src/plot/label-tex.ts`), меняющей TeX: скобки, отступ, имя
 * функции. Правило то же, что у `PLOT_RENDERER_VERSION` в `plot/spec.ts`: не
 * поднять значит оставить на слайдах подписи двух видов, а дозаливка их не
 * отличит.
 */
export const LABEL_TEX_VERSION = 1;

/**
 * Самая старая версия, которую ещё можно показывать.
 *
 * ⚠️ Поднимается, ТОЛЬКО если правка печатника исправила НЕВЕРНУЮ подпись:
 * тогда подписи старых версий гаснут, пока их не дозальют. Правка вида (скобки,
 * отступ) его не трогает: старая подпись верна и показывается дальше.
 */
export const LABEL_TEX_MIN_SHOWN = 1;
